import * as Toolkit from '../../../toolkit/index';
import * as CubeTree from '../../../cubeTree/index';
import CodiSystem from '../../../codiSystem/index';

function findDirection(layerChild: CubeId, mousePoint: MousePoint, dragCubes: CubeId[]): PointOfRectDirection {
    let layerChildCoordinate: PaintCoordinate = CodiSystem.getPaintCoordinate(layerChild);
    let point: MousePoint = {
        ...mousePoint
    };
    let rect: Rect = {
        left: layerChildCoordinate.left,
        top: layerChildCoordinate.top,
        width: layerChildCoordinate.width,
        height: layerChildCoordinate.height
    };
    let middleArea: number = 0.5;

    /**
     * 不显示字码插入箭头
     *
     * 1. 拖拽多个cube
     * 2. 拖拽的不是商品
     * 3. 插入对象不是商品
     * 4. 本身是含有字母的商品
     * 5. 所在层板不是字母码拖拽
     */
    let theFirst: CubeId = dragCubes[0];
    let parent: CubeId = CubeTree.findParentIdByCubeId(layerChild);

    if (dragCubes.length > 1
        || !CubeTree.isGoods(theFirst)
        || !CubeTree.isGoods(layerChild)
        || CubeTree.hasSubGoods(theFirst)
        || !CubeTree.layerIsSubDrag(parent)) {
        middleArea = 0;
    }

    return Toolkit.pointOfRectDirection(point, rect, middleArea);
}

export {
    findDirection
};
